import { OrderMatchOfferToProductCommandHandler } from "./commands/order-match-offer-to-product.command";
import { OrderUpdateStatusCommandHandler } from "./commands/order-update-status.command";
import { OrderRepository } from "./order.repo";
import { OrderCollectionQueryHandler } from "./queries/order-grid.query";
import { OrderStatusesQueryHandler } from "./queries/order-statuses.query";
import { SelloViewsQueryHandler } from "./queries/sello-views.query";

const OrdersProviders = [
    OrderRepository,
    OrderCollectionQueryHandler,
    OrderStatusesQueryHandler,
    OrderUpdateStatusCommandHandler,
    SelloViewsQueryHandler,
    OrderMatchOfferToProductCommandHandler
] as const;
export { OrdersProviders };

